export default __webpack_public_path__ + "static/media/key.4c8b5b39.jpg";